import { ContentContainer } from "@/components/ContentContainer";
import MarkdownContent from "@/components/MarkdownContent";
import RegisterForm from "@/components/register/RegisterForm";
import { contentFullscreenState } from "@/context/states";
import { basierCirleBold } from "@/styles/fonts";
import theme from "@/styles/theme";
import { Box, Button, Grid, Typography } from "@mui/material";
import Link from "next/link";
import { Fragment, useEffect } from "react";
import { useRecoilState } from "recoil";

export default function SocialLpPage({ page }) {
  const [contentFullscreen, setContentFullscreen] = useRecoilState(
    contentFullscreenState,
  );

  useEffect(() => {
    setContentFullscreen(true);
  }, []);

  const disableFullScreen = () => {
    setContentFullscreen(false);
  };

  return (
    <Fragment>
      <ContentContainer
        headline={page.headline}
        image={page?.hero_image?.formats?.large?.url}
      >
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="baseline"
        >
          <Grid item xs={12} md={6}>
            <MarkdownContent input={page.content_text_left} />
          </Grid>
          <Grid item xs={12} md={6}>
            <MarkdownContent input={page.content_text_right} />
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "center" }}>
            <Button
              variant="contained"
              component="a"
              color="primary"
              href="#registrieren"
            >
              Jetzt registrieren
            </Button>
          </Grid>
        </Grid>

        <Box
          sx={{
            [theme.breakpoints.up("sm")]: { transform: "skewX(-5deg)" },
            bgcolor: theme.palette.secondary.main,
            color: theme.palette.common.white,
            px: 2,
            py: 0.5,
            my: 4,
          }}
        >
          <Grid
            container
            justifyContent="center"
            spacing={2}
            sx={{
              my: 2,
              [theme.breakpoints.up("sm")]: { transform: "skewX(5deg)" },
            }}
          >
            <Grid item xs={12}>
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1.25rem",
                  textWrap: "balance",
                  mb: 2,
                }}
              >
                {page.content_text_bottom}
              </Typography>
            </Grid>
            {page.content_button_caption && (
              <Grid item xs="auto">
                <Button
                  component={Link}
                  onClick={disableFullScreen}
                  href={page.content_button_target}
                  variant="outlined-white-x"
                  sx={{ mb: 1.5 }}
                >
                  {page.content_button_caption}
                </Button>
              </Grid>
            )}
          </Grid>
        </Box>

        <Grid
          container
          spacing={2}
          justifyContent="center"
          sx={{ mb: 8 }}
          id="registrieren"
        >
          <Grid item xs={12} md={8}>
            <RegisterForm />
          </Grid>
        </Grid>

        {page.faq?.map((faq) => (
          <div key={`faq-${faq.id}`}>
            <Typography
              variant="body1"
              component="h2"
              color="common.black"
              sx={{
                fontWeight: basierCirleBold.style.fontWeight,
                fontFamily: basierCirleBold.style.fontFamily,
                fontSize: "1.375rem !important",
                textTransform: "uppercase",
                mb: 1,
                mt: 4,
              }}
            >
              {faq.title}
            </Typography>
            <MarkdownContent input={faq.content} />
          </div>
        ))}
      </ContentContainer>
    </Fragment>
  );
}

export const getStaticProps = async () => {
  const pageResponse = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/seite-campaign-lp-default`,
  );
  const page = await pageResponse.json();

  return {
    props: {
      page,
    },
    revalidate: parseInt(process.env.SSG_REVALIDATE_TIMEOUT),
  };
};
